module.exports = __webpack_public_path__ + "img/CopyLight.d5a156dc.svg";